import { FC, ReactElement, useMemo } from 'react';

import { CrossIcon, LeftChevronIcon } from '../../icons';

import { ChildrenWrapper, Root, Title, TopButton } from './SearchHeader.styles';

export type TSearchHeaderVariant =
	| 'secondary'
	| 'primary'
	| 'yellow'
	| 'primary_light'
	| 'light'
	| 'grey'
	| 'white'
	| 'light_blue'
	| 'primary_dark';

export interface SearchHeaderProps {
	open: boolean;
	showBack?: boolean;
	showClose?: boolean;
	onBack?: () => void;
	onClose?: () => void;
	variant?: TSearchHeaderVariant;
	transparent?: boolean;
	title?: string;
	children?: ReactElement | null;
}

/** @deprecated */
export const SearchHeader: FC<SearchHeaderProps> = ({
	open,
	showBack = false,
	showClose = false,
	onBack,
	onClose,
	variant = 'primary',
	transparent,
	title,
	children,
}) => {
	const hasChildren = Boolean(children);

	const ownerState = useMemo(
		() => ({
			variant,
			open,
			rounded: Boolean(title || hasChildren),
			transparent,
		}),
		[hasChildren, open, title, variant, transparent]
	);

	return (
		<Root ownerState={ownerState}>
			{showBack ? (
				<TopButton
					type="button"
					key="back"
					left
					variant="text"
					onClick={onBack}
					data-testid="drawer-back-button"
					id="backButton"
				>
					<LeftChevronIcon />
				</TopButton>
			) : null}
			{showClose ? (
				<TopButton
					type="button"
					key="close"
					variant="text"
					onClick={onClose}
					data-testid="drawer-close-button"
					id="closeButton"
				>
					<CrossIcon />
				</TopButton>
			) : null}
			{title ? <Title data-testid="drawer-header-text">{title}</Title> : null}
			{children ? <ChildrenWrapper>{children}</ChildrenWrapper> : null}
		</Root>
	);
};

export default SearchHeader;
